export const MAIN_EMAIL = "nikolexfenetres@gmail.com";
export const MAIN_PHONE = "+33652112144";
export const SECONDARY_PHONE = "+33679571653";